import apiClient from './api';

export const userProfileService = {
  getAll: async () => {
    const res = await apiClient.get('/UserProfiles');
    return res.data;
  },
  create: async (payload) => {
    const res = await apiClient.post('/UserProfiles', payload);
    return res.data;
  },
  getById: async (id) => {
    try {
      const res = await apiClient.get(`/UserProfiles/${id}`);
      return res.data;
    } catch (err) {
      // If the server returns 400/404 for an unexpected id, return null to let callers try other fallbacks
      // Log for debugging
      console.warn('userProfileService.getById failed for id', id, err?.response?.status, err?.response?.data || err.message);
      return null;
    }
  },
  update: async (id, payload) => {
    const res = await apiClient.put(`/UserProfiles/${id}`, payload);
    return res.data;
  },
  delete: async (id) => {
    const res = await apiClient.delete(`/UserProfiles/${id}`);
    return res.data;
  },
  getByUserId: async (userId) => {
    // Prefer the explicit user route, but tolerate some backends that might expose profile directly at /UserProfiles/{userId}
    try {
      const res = await apiClient.get(`/UserProfiles/user/${userId}`);
      return res.data;
    } catch (err) {
      console.warn('getByUserId primary route failed, trying fallback /UserProfiles/{userId}', err?.response?.status);
      try {
        const res2 = await apiClient.get(`/UserProfiles/${userId}`);
        return res2.data;
      } catch (err2) {
        console.warn('userProfileService.getByUserId fallback also failed for userId', userId, err2?.response?.status, err2?.response?.data || err2.message);
        return null;
      }
    }
  },
  postPsychometric: async (userId, payload) => {
    const res = await apiClient.post(`/UserProfiles/user/${userId}/psychometric`, payload);
    return res.data;
  }
};

export default userProfileService;
